import { render } from "./SetPeriod.vue?vue&type=template&id=8f543d86&scoped=true"
import script from "./SetPeriod.vue?vue&type=script&lang=js"
export * from "./SetPeriod.vue?vue&type=script&lang=js"

import "./SetPeriod.vue?vue&type=style&index=0&id=8f543d86&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f543d86"]])

export default __exports__